import useHelpers from "composables/useHelpers.js";
import axios from "axios";

export const DEFAULT_MEETING = {
  id: null,
  name: "",
  meeting_type: "meeting",
  status: "concept",
  school_id: null,
  mail_student: null,
  mail_student_summary_text:
    "Wat ging er volgens jou goed de afgelopen periode?",
  mail_student_text:
    "Hierbij ontvang je van ons de tussentijdse feedback. Graag ontvangen we het actieplan van je voor de volgende bespreking met de mentor of de ouderavond.",
  allow_student_ratings: null,
  allow_student_checkins: null,
  allow_grades: null,
  message: "",
  mentor_classes: [],
  schedules: [],
  teacher_scores: [],
  total_ratings: null,
  total_given_ratings: null,
  reports_shared: [],
  timeframes: {},
};

export class Meeting {
  constructor(data = {}) {
    this.id = data.id ?? DEFAULT_MEETING.id;
    this.name = data.name ?? DEFAULT_MEETING.name;
    this.status = data.status ?? DEFAULT_MEETING.status;
    this.school_id = data.school_id ?? DEFAULT_MEETING.school_id;
    this.mail_student = data.mail_student ?? DEFAULT_MEETING.mail_student;
    this.mail_student_summary_text =
      data.mail_student_summary_text ??
      DEFAULT_MEETING.mail_student_summary_text;
    this.mail_student_text =
      data.mail_student_text ?? DEFAULT_MEETING.mail_student_text;
    this.allow_student_ratings =
      data.allow_student_ratings ?? DEFAULT_MEETING.allow_student_ratings;
    this.allow_student_checkins =
      data.allow_student_checkins ?? DEFAULT_MEETING.allow_student_checkins;
    this.allow_grades = data.allow_grades ?? DEFAULT_MEETING.allow_grades;
    this.message = data.message ?? DEFAULT_MEETING.message;
    this.mentor_classes = data.mentor_classes ?? DEFAULT_MEETING.mentor_classes;
    this.schedules = data.schedules ?? DEFAULT_MEETING.schedules;
    this.teacher_scores = data.teacher_scores ?? DEFAULT_MEETING.teacher_scores;
    this.total_ratings = data.total_ratings ?? DEFAULT_MEETING.total_ratings;
    this.total_given_ratings =
      data.total_given_ratings ?? DEFAULT_MEETING.total_given_ratings;
    this.reports_shared = data.reports_shared ?? DEFAULT_MEETING.reports_shared;
    this.timeframes = data.timeframes ?? DEFAULT_MEETING.timeframes;
    this.meeting_type = data.meeting_type ?? DEFAULT_MEETING.meeting_type;
  }

  async store() {
    try {
      const { schoolId } = useHelpers();

      let formData = new FormData();
      formData.set("meeting", JSON.stringify(this));

      const { data } = axios.post(`/api/school/${schoolId}/meetings`, formData);
      return data;
    } catch (error) {
      console.log(`meetingModel.js:store ~ error:`, error);
      throw new Error(error);
    }
  }

  async updateGlobalInfo() {
    try {
      const { data } = axios.post(
        `/api/meetings/${this.id}/update-global-info`,
        {
          name: this.name,
          message: this.message,
          mail_student: this.mail_student === "true" || this.mail_student === 1,
          mail_student_text: this.mail_student_text,
          mail_student_summary_text: this.mail_student_summary_text,
          allow_student_ratings:
            this.allow_student_ratings === "true" ||
            this.allow_student_ratings === 1,
          allow_grades: this.allow_grades,
          allow_student_checkins: this.allow_student_checkins,
        },
      );

      return data;
    } catch (error) {
      throw new Error(error);
    }
  }

  async updatePlanning(timeframes) {
    try {
      const formData = new FormData();
      formData.set("timeframe_settings", JSON.stringify(timeframes));

      return await axios.post(
        `/api/meetings/${this.id}/update-planning`,
        formData,
      );
    } catch (error) {
      throw new Error(error);
    }
  }
}
